import { createTheme } from "@mui/material";
import { ptBR as corePtBR } from "@mui/material/locale";
import { ptBR } from "@mui/x-data-grid/locales";
import { ptBR as pickersPtBR } from "@mui/x-date-pickers/locales";

export const MUI_THEME = createTheme({}, ptBR, pickersPtBR, corePtBR);
